
/*********************************************************************************************
 * Splide Products reco
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    const sectionCollectionProduct = document.querySelectorAll('[data-section-collection-product-id]');
    let scrollCounter = 0;

    sectionCollectionProduct.forEach(function (section) {
        const id = '.mm-collection-product-collection-splide';
        const splideElem = section.querySelector(id);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            mmSplideInit(splideElem, section);
        }
    });

    function mmSplideInit(splideElem, section) {
        var splideInstance = new Splide(splideElem, {
            type            : 'slide',
            arrows          : true,
            pagination      : false,
            autoplay        : false,
            perPage         : 4,
            perMove         : 2,
            padding         : {
                left    : 16,
                right   : 16,
            },
            breakpoints     : {
                1200: {
                    perPage     : 3,
                },
                950 : {
                    perPage     : 2,
                },
                768 : {
                    perPage     : 1,
                    perMove     : 1,
                    arrows      : false,
                    pagination  : false,
                    padding     : {
                            left        : 0,
                            right       : 0,
                        },
                    }
                },
                gap: 16
        }).mount();

        // Mise à jour lors des mouvements ou drag du carrousel
        splideInstance.on('moved', updateProgressBar);
        splideInstance.on('dragged', updateProgressBar);

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });

    }
});
